import axios from 'axios';
// Use the application's configured client, including token refresh/retry.
const config = extra => ({ baseURL: process.env.REACT_APP_API_URL, withCredentials: true, ...extra });
export const warehouseApi = {
  get: (url, extra) => axios.get(url, config(extra)),
  post: (url, data, extra) => axios.post(url, data, config(extra)),
  patch: (url, data, extra) => axios.patch(url, data, config(extra)),
};
export const operationKey = () => window.crypto?.randomUUID?.() || `warehouse-${Date.now()}-${Math.random().toString(36).slice(2)}`;
export const apiError = err => err.response?.data?.message || err.response?.data?.error || 'No se pudo completar la operación.';
